export const FETCH_DATA = 'SERVICES:FETCH_DATA';
export const FETCH_DATA_SUCCESS = 'SERVICES:FETCH_DATA_SUCCESS';
export const FETCH_DATA_ERROR = 'SERVICES:FETCH_DATA_ERROR';
